import styled from "styled-components";

export default styled.button`
  padding: 3px 5px;
  border: 1px solid black;
  border-radius: 5px;
`;
